import "./logging";
import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app";
import "../resources/styles.css";
import { I18nextProvider } from "react-i18next";
import i18n from "./config/i18n";
import { AuthProvider } from "./context/authProvider";
import { LicenseInfo } from "@mui/x-license";
import { AuthenticationTokenProvider } from "./context/AuthenticationTokenContext";
import "./date-modifier";

function init() {
  LicenseInfo.setLicenseKey(
    "15e62273bdfca44e9b3285557b712b64Tz0xMjA5MjMsRT0xNzkzNTc3NTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=",
  );
  const el = document.getElementById("app");
  const root = createRoot(el);

  root.render(
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <AuthenticationTokenProvider>
          <App />
        </AuthenticationTokenProvider>
      </AuthProvider>
    </I18nextProvider>,
  );
}

init();
